import type { VehicleTyreLayout } from '@chukua/common';
import { Select } from 'antd';
import { VehicleTyreDiagram } from './VehicleTyreDiagram';

/** The vehicle a tyre is being rotated on and the position it is leaving, which cannot be its own destination. */
export interface RotationContext {
  layout: VehicleTyreLayout;
  fromPositionCode: string;
}

interface RotateTargetPickerProps {
  /** Form.Item supplies these. */
  value?: string;
  onChange?: (code: string) => void;
  options: { value: string; label: string }[];
  rotation: RotationContext | null;
}

/** Where a tyre goes: pick the position from the list or click it on the vehicle, so the two always agree. */
export function RotateTargetPicker({ value, onChange, options, rotation }: RotateTargetPickerProps) {
  const isChoosable = (code: string) => options.some((option) => option.value === code);
  const pick = (code: string) => {
    if (isChoosable(code)) onChange?.(code);
  };
  return (
    <div className="flex flex-col gap-3">
      <Select value={value} onChange={onChange} options={options} placeholder="Select a position" />
      {rotation && (
        <>
          <p className="m-0 text-xs text-muted">
            Moving from <span className="font-medium text-fg">{rotation.fromPositionCode}</span>. Click the position you want on the vehicle.
          </p>
          <VehicleTyreDiagram layout={rotation.layout} selectedCode={value ?? rotation.fromPositionCode} onSelect={pick} className="lg:static" />
        </>
      )}
    </div>
  );
}
